import { apiClient } from './api-client';

export interface SessionImage {
  index: number;
  character: string;
  imageUrl: string;
}

export interface CreateSessionResponse {
  session: {
    id: string;
    userId: number;
    totalImages: number;
    status: string;
    characters: string[];
    correctCount: number;
    createdAt: string;
  };
  images: SessionImage[];
}

export interface SessionAnswer {
  id: string;
  sessionId: string;
  imageIndex: number;
  expectedCharacter: string;
  userAnswer: string | null;
  isCorrect: boolean;
  status: string;
  createdAt: string;
}

export interface SessionCompleteResponse {
  sessionId: string;
  totalImages: number;
  correctCount: number;
  accuracy: number;
  answers: SessionAnswer[];
}

export const imageContributionsApi = {
  async createSession(totalImages = 10): Promise<CreateSessionResponse> {
    const { data } = await apiClient.post('/image-contributions/session', { totalImages });
    return data.data;
  },

  async getSession(sessionId: string) {
    const { data } = await apiClient.get(`/image-contributions/session/${sessionId}`);
    return data.data;
  },

  async submitAnswer(
    sessionId: string,
    imageIndex: number,
    userAnswer: string,
    expectedCharacter: string,
    isCorrect: boolean,
  ): Promise<SessionAnswer> {
    const { data } = await apiClient.post(`/image-contributions/session/${sessionId}/answer`, {
      imageIndex,
      userAnswer,
      expectedCharacter,
      isCorrect,
    });
    return data.data;
  },

  async completeSession(sessionId: string): Promise<SessionCompleteResponse> {
    const { data } = await apiClient.post(`/image-contributions/session/${sessionId}/complete`);
    return data.data;
  },
};
